import { canViewRoleAndCapabilities, canViewUser } from "@common/utils/user";
import { getUserRoles } from "@services/user";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";
import { Role } from "@services/user/types";
import React, {
  createContext,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";

export type RoleContextType = {
  roles: Role[];
};

const defaultValues: RoleContextType = {
  roles: [],
};
export const RoleContext = createContext<RoleContextType>(defaultValues);

export const RoleProvider = (props: PropsWithChildren<{}>) => {
  const [roles, setRoles] = useState<Role[]>();
  const [user] = useAuthenticatedUser();
  const canViewRoles = canViewRoleAndCapabilities(user);
  const canViewUsers = canViewUser(user);

  const refetch = async () => {
    try {
      setRoles(await getUserRoles());
    } catch (e) {}
  };

  useEffect(() => {
    if (canViewRoles && canViewUsers) refetch();
  }, []);

  return (
    <RoleContext.Provider value={{ ...defaultValues, roles: roles ?? [] }}>
      {props.children}
    </RoleContext.Provider>
  );
};
